import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import styled from "styled-components";
import colors from "../../theme/colors";
import { Link } from "react-router-dom";

// --- Styled Components ---

const AlarmCard = styled(Paper)`
  display: flex;
  max-width: 400px;
  width: 100%;
  padding: 15px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

const HeaderRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const Title = styled(Typography)`
  && {
    font-weight: bold;
    color: ${colors.grayDarkText};
    font-size: 12px;
  }
`;

const AlarmCountText = styled(Typography)`
  && {
    color: ${(props) =>
      props.$count > 0 ? colors.red || "#d32f2f" : colors.green};
    font-weight: bold;
    font-size: 35px;
  }
`;

const HistoryText = styled(Typography)`
  && {
    color: ${colors.grayDarkText};
    font-size: 12px;
  }
`;

export function ActiveAlarmsWidget({
  metricTitle = "Active Alarms",
  alarmCount = 0,
  historyPeriodDays = 30,
  historicalCount = 0,
  toPath,
  disabled = false,
}) {
  return (
    <AlarmCard>
      {/* Header and Action Control Row */}
      <HeaderRow>
        <Title>{metricTitle.toUpperCase()}</Title>
        <Button
          sx={{
            boxShadow: 2,
            fontSize: "10px",
            padding: "4px 12px",
            minWidth: "auto",
          }}
          size="small"
          color="black"
          to={toPath}
          component={Link}
          disabled={disabled}
        >
          View
        </Button>
      </HeaderRow>

      {/* Main Counter Indicator */}
      <AlarmCountText $count={alarmCount}>
        {alarmCount}
      </AlarmCountText>

      {/* Historical Track Disclosures */}
      <HistoryText variant="body2">
        Alarms Last {historyPeriodDays}d: {historicalCount}
      </HistoryText>
    </AlarmCard>
  );
}

export default ActiveAlarmsWidget;
